// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChartToolsIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ChartToolsIcon" ref={forwardedRef} {...props}>
      <path d="M4.5 3H3v13a1 1 0 0 0 1 1h13v-1.5H4.5z" />
      <path d="M8 6H6v8h2z" />
      <path d="M10 8h2v6h-2z" />
      <path d="M12.5 5.501A2.5 2.5 0 0 1 14 3.209v2.292a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3.209a2.5 2.5 0 0 1 0 4.584V14h-2V7.793A2.5 2.5 0 0 1 12.5 5.5" />
    </SvgIcon>
  );
});

/**
 * Configurations and options for customization that only influence a selected chart.
 * @public
 */
export const ChartToolsIcon = /* @__PURE__ */ Object.assign(
  ChartToolsIconComponent,
  { displayName: 'ChartToolsIcon' },
);
